import React from "react";
import { BooleanField, BulkDeleteButton, Datagrid, EditButton, List, TextField } from "react-admin";
import { SearchableList } from "../SearchableList";

export const ListComponent: React.FC = () => {
  return (
    <List perPage={100}>
      <SearchableList>
      <Datagrid
        rowClick="show"
        bulkActionButtons={<BulkDeleteButton mutationMode="optimistic" />}
        sx={{
          '& tbody tr:nth-of-type(odd)': { backgroundColor: '#1a1a1a' },
          '& tbody tr:nth-of-type(even)': { backgroundColor: '#000000' },
        }}
      >
        <TextField label="Name" source="name" />
        <TextField label="Serial number" source="serial_number" />
        <TextField label="Location" source="location.name" />
        <BooleanField label="Active" source="is_active" />
        <EditButton />
      </Datagrid>
      </SearchableList>
    </List>
  );
};
